var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"mr-2 rounded",attrs:{"color":_vm.color}},[_c('strong',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }